import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { TrendingUp, ArrowUpRight } from "lucide-react";
import { Counter } from "@/components/site/Counter";

const VELOCITY = [
  { q: "Q1 25", Monaco: 62, Geneva: 70 },
  { q: "Q2 25", Monaco: 66, Geneva: 73 },
  { q: "Q3 25", Monaco: 64, Geneva: 71 },
  { q: "Q4 25", Monaco: 71, Geneva: 76 },
  { q: "Q1 26", Monaco: 78, Geneva: 82 },
  { q: "Q2 26", Monaco: 84, Geneva: 88 },
];

const MOVERS = [
  { label: "Relationship Mgmt comp", change: "+6.2%", up: true },
  { label: "Compliance & Risk comp", change: "+9.4%", up: true },
  { label: "Time-to-hire (senior)", change: "-11%", up: true },
  { label: "Geneva → Monaco flow", change: "Net positive", up: true },
];

export const TalentBarometer = () => {
  return (
    <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.25fr_0.75fr]" data-testid="talent-barometer">
      <div className="rounded-[var(--radius-lg)] border border-[color:var(--bp-border)] bg-[color:var(--bp-surface)] p-7">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-[color:var(--bp-teal)]/40 bg-[color:var(--bp-teal-soft)] text-[color:var(--bp-teal)]"><TrendingUp className="h-5 w-5" /></span>
          <div>
            <h3 className="font-display text-xl font-semibold text-[color:var(--bp-cream)]">Hiring velocity index</h3>
            <p className="text-[13px] text-[color:var(--bp-text-muted)]">Monaco vs Geneva · last six quarters</p>
          </div>
        </div>
        <div className="mt-6 h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={VELOCITY} margin={{ top: 8, right: 12, left: -16, bottom: 0 }}>
              <defs>
                <linearGradient id="gGeneva" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#2DB5A5" stopOpacity={0.4} /><stop offset="100%" stopColor="#2DB5A5" stopOpacity={0} /></linearGradient>
                <linearGradient id="gMonaco" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#D4AF37" stopOpacity={0.35} /><stop offset="100%" stopColor="#D4AF37" stopOpacity={0} /></linearGradient>
              </defs>
              <CartesianGrid vertical={false} stroke="#144970" strokeOpacity={0.4} />
              <XAxis dataKey="q" tick={{ fontSize: 12, fill: "#C5BFB6" }} />
              <YAxis tick={{ fontSize: 11, fill: "#C5BFB6" }} domain={[40, 100]} />
              <Tooltip contentStyle={{ background: "#0D2B4D", border: "1px solid #144970", borderRadius: 10, color: "#F5F1EB" }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Area type="monotone" dataKey="Geneva" stroke="#2DB5A5" strokeWidth={2.5} fill="url(#gGeneva)" />
              <Area type="monotone" dataKey="Monaco" stroke="#D4AF37" strokeWidth={2.5} fill="url(#gMonaco)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="rounded-[var(--radius-lg)] border border-[color:var(--bp-border)] bg-[color:var(--bp-surface)] p-7">
        <p className="eyebrow text-[color:var(--bp-gold)]">Q2 2026 movers</p>
        <div className="mt-5 space-y-3">
          {MOVERS.map((m) => (
            <div key={m.label} className="flex items-center justify-between rounded-[var(--radius-md)] border border-[color:var(--bp-border)] bg-[color:var(--bp-bg-2)] px-4 py-3.5">
              <span className="text-[13.5px] text-[color:var(--bp-cream)]">{m.label}</span>
              <span className="inline-flex items-center gap-1 text-[13px] font-semibold text-[color:var(--bp-teal)]"><ArrowUpRight className="h-3.5 w-3.5" /> {m.change}</span>
            </div>
          ))}
        </div>
        <div className="mt-6 rounded-[var(--radius-md)] border border-[color:var(--bp-border)] bg-[color:var(--bp-bg-2)] p-5 text-center">
          <p className="font-display text-4xl font-semibold text-[color:var(--bp-gold)]"><Counter value={88} /></p>
          <p className="mt-1 text-[12.5px] text-[color:var(--bp-text-muted)]">Geneva velocity index, Q2 2026</p>
        </div>
      </div>
    </div>
  );
};
